let _ = t => t,
  _t;
import { GYPSUM } from 'HubStyleTokens/colors';
import styled from 'styled-components';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
const UnavailableProductLevelButton = styled.div.withConfig({
  displayName: "UnavailableProductLevelButton",
  componentId: "sc-1j8ib4a-0"
})(["width:calc(100% / 3);background-color:", ";font-size:14px;", ""], GYPSUM, breakpoint.phone(_t || (_t = _`
    display: none;
  `)));
export default UnavailableProductLevelButton;